import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';

export const DRIVER_LANG_STORAGE_KEY = 'ubus_driver_lang';

export type DriverLanguage = 'en' | 'zh-CN';

export function readStoredDriverLanguage(): DriverLanguage {
  const raw = localStorage.getItem(DRIVER_LANG_STORAGE_KEY);
  if (raw === 'zh-CN' || raw === 'en') return raw;
  return 'en';
}

export function persistDriverLanguage(lang: DriverLanguage): void {
  localStorage.setItem(DRIVER_LANG_STORAGE_KEY, lang);
  document.documentElement.lang = lang === 'zh-CN' ? 'zh-CN' : 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    'zh-CN': { translation: zhCN },
  },
  lng: typeof window !== 'undefined' ? readStoredDriverLanguage() : 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

if (typeof window !== 'undefined') {
  persistDriverLanguage(readStoredDriverLanguage());
}

export async function setDriverLanguage(lang: DriverLanguage): Promise<void> {
  persistDriverLanguage(lang);
  await i18n.changeLanguage(lang);
}

export default i18n;
